import { z } from 'zod'
import {
  errorDataSchema,
  eventDataSchema,
  userDataSchema,
  zodLoginMethodEnum,
} from '../../common.schema'

export const LoginFailureSchema = z.object({
  event: z.literal('login_failure'),

  user_data: userDataSchema.extend({
    login_method: zodLoginMethodEnum,
  }),
  event_data: eventDataSchema,
  error_data: errorDataSchema,
})

export type LoginFailureEvent = z.infer<typeof LoginFailureSchema>
